import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileManagerComponent } from './file-manager.component';
import { fileManagerRoutingModule } from './file-manger-routing.module';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatTreeModule} from '@angular/material/tree';
import { MatCardModule } from '@angular/material/card';
import { DocDetailComponent } from './doc-detail/doc-detail.component';
import {MatTabsModule} from '@angular/material/tabs';
import { InboxComponent } from './inbox/inbox.component';
import { TrashComponent } from './trash/trash.component';
import { LeftMenuComponent } from './left-menu/left-menu.component';
import { FileDashboardComponent } from './file-dashboard/file-dashboard.component';
import {DocumentViewerComponent} from './document-viewer/document-viewer.component';
import { StarredComponent } from './starred/starred.component';
import { ApiEndPointsFileManager } from './common/apiUrls/api-end-points-fileManager';
import {FileManagerService} from './services/fileManager.services';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { MatSortModule } from '@angular/material/sort';
import { SharedModule } from 'src/app/middleware/shared/shared.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from 'src/app/middleware/authentication/interceptor/auth-interceptor';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ApiEndPointsContact } from '../company/common/apiUrls/api-end-points-contact';
import { ContactsService } from '../company/services/contacts.service';
import { ApiEndPointsDocument } from '../company/common/apiUrls/api-end-points-document';
import { ContactsVm,ContactVm, FilteredContactVm } from 'src/app/viewModels/core/contacts-vm';
import { AssociateContactRoleFileManagerComponent } from './associate-contact-role-filemanager/associate-contact-role-filemanager.component';
import { AssociateContactRoleFileManagerListComponent } from './associate-contact-role-filemanager-list/associate-contact-role-filemanager-list.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { GoogleAuthService } from './services/google-auth.service.ts';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [AssociateContactRoleFileManagerComponent,AssociateContactRoleFileManagerListComponent,FileManagerComponent, DocDetailComponent, InboxComponent, TrashComponent, LeftMenuComponent, FileDashboardComponent,DocumentViewerComponent, StarredComponent],
  imports: [
    CommonModule,
    fileManagerRoutingModule,
    MatIconModule,
    FlexLayoutModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatTreeModule,
    MatCardModule,
    MatTabsModule,
    MatTableModule,
    MatPaginatorModule,
    MatChipsModule,
    MatDatepickerModule,
    NgxDocViewerModule,
    MatSortModule,
    MatProgressSpinnerModule,
    SharedModule,   
    NgxDaterangepickerMd,
    DragDropModule,
  ],
  
  providers:[
    ApiEndPointsFileManager,
    FileManagerService,
    GoogleAuthService,
    LoaderService,
    ApiEndPointsContact,
    ContactsService,
    ApiEndPointsDocument,
    FilteredContactVm,
    ContactsVm,  
    ContactVm,
    {provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true},
  ]
})
export class FileManagerModule { }
